<script>
  // import Service from '../../../../../domain/leiloes/services'

  let data = {
    opened: false,
    htmlLoaded: false,
    html: '',
    arrematante: {},
    historicoCobranca: [],
    dados: {},
    anexos: [],
    emails: [],
    lote: null,
    enviando: false,
    enviadoSucesso: null,
    load: null,
    enviarEmail: null
  }

  export default {
    name: 'email-view',
    props: {
    },
    data () {
      return JSON.parse(JSON.stringify(data))
    },
    computed: {},
    mounted () {
    },
    destroyed () {
      this._unmount()
    },
    methods: {
      open (fncLoad, fcnSend) {
        console.log('Open')
        this.load = fncLoad
        this.enviarEmail = fcnSend
        this.enviando = false
        this.enviadoSucesso = null
        let _body = document.querySelector('body')
        _body.classList.add('hide-scroll')
        this.html = '<i class="fa fa-spinner fa-spin"></i>'
        this.opened = true
        this.$nextTick(() => {
          this.load()
        })
        return this
      },
      close () {
        this.opened = false
        this._unmount()
      },
      bindLoad (response) {
        this.html = response.data.template
        this.arrematante = response.data.arrematante
        this.historicoCobranca = response.data.historicoCobranca
        this.dados = response.data
        this.htmlLoaded = true
        this.emails = this.arrematante.pessoa.emails.map((e) => e.email)
      },
      _unmount () {
        this.htmlLoaded = false
        let _body = document.querySelector('body')
        _body.classList.remove('hide-scroll')
      },
      enviar () {
        this.enviando = true
        this.enviadoSucesso = null
        let dados = {
          emails: this.emails,
          html: this.$refs.html.innerHTML
        }
        this.enviarEmail(dados)
          .then((response) => {
            this.enviando = false
            this.enviadoSucesso = true
            this.historicoCobranca = response.data.historicoCobranca
            console.log(response)
          })
          .catch((error) => {
            this.enviando = false
            this.enviadoSucesso = false
            window.responseError(error)
          })
      }
    },
    components: {}
  }
</script>

<template>
  <div>
    <div class="side-panel-overlay" @click="close" :class="{'open': opened}">
    </div>
    <div class="view-container" :class="{'open': opened}">
      <span @click="close" class="side-panel-close" title="Close">
        <span class="side-panel-close-inner"></span>
      </span>
      <span class="side-panel-print side-panel-print-visible" title="Print"></span>
      <div class="panel-opt">
        <u-button @click="enviar" :disabled="enviando" class="btn btn-info" :class="{'btn-addon': !enviando}">
          <span v-if="!enviando"><i class="fa fa-send-o"></i> Enviar e-mail</span>
          <span v-if="enviando"><i class="fa fa-spin fa-spinner m-r"></i> Aguarde</span>
        </u-button>
        <span v-if="enviadoSucesso === true" class="block m-t alert alert-success bg-success">Enviado com sucesso</span>
        <span v-else-if="enviadoSucesso === false" class="block m-t alert alert-danger bg-danger">Aconteceu algum problema ao tentar processar o envio do e-mail</span>
        <span v-else></span>
      </div>
      <div class="panel-rest">
        <div ref="html" class="inner-html" :class="{'loaded': htmlLoaded}" v-html="html" contentEditable="true"></div>
        <div class="options" v-if="htmlLoaded">
          <div class="wrapper-sm">
            <div class="tip1">
              <div class="title">Arrematante:</div>
              <div class="value">{{ arrematante.apelido }}</div>
            </div>


            <div class="tip2">
              Histórico
            </div>
            <div class="tip1" v-for="com in historicoCobranca">
              <div class="title">{{ moment(com.data.date).format('L LTS') }}</div>
              <div class="value">
                <span><i class="fa fa-bell-o"></i></span>
                <span v-if="com.tipo === 0">
                    <strong class="text-danger"
                            v-if="com.dados && com.dados.pagamentoPendente"> Cobrança de pagamento pendente</strong>
                    <span v-else>Cobrança</span>
                  </span>
                <span v-if="com.tipo === 1">Baixa oferta</span>
                <span v-if="com.tipo === 2">Condicional</span>
                <span v-if="com.tipo === 3" class="text-warning">Cobrança Desistência</span>
                <span v-if="com.tipo === 4" class="alert alert-danger font-bold text-uppercase m-l-xs" style="padding: 4px">Negativação</span>
              </div>
            </div>
            <div class="tip2">
              Destinatários
            </div>
            <div class="tip1" v-for="email in arrematante.pessoa.emails">
              <div class="title">Email:</div>
              <div class="value">
                {{ email.email }}
              </div>
            </div>
            <div class="tip2">
              Anexos
            </div>
            <div class="tip2" v-for="anexo in anexos">
              {{ anexo.nome }}
            </div>
            <div class="tip2 tip2-content no-border" v-if="!anexos || anexos.length < 1">Nenhum anexo</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .side-panel-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3000;
    display: none;
    background-color: rgba(0, 0, 0, .4);
    transform: translateZ(0);
    overflow: hidden;
    &.open {
      display: block;
    }
  }

  .side-panel-close {
    position: absolute;
    top: 0;
    left: -64px;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    cursor: pointer;
    transition: opacity .3s;
  }

  .side-panel-close-inner:after, .side-panel-close-inner:before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 2px;
    background-color: #fff;
    content: "";
  }

  .side-panel-close:hover .side-panel-close-inner {
    border: 2px solid rgba(255, 255, 255, 1);
    background-color: rgba(0, 0, 0, .2);
  }

  .side-panel-close-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -18px;
    margin-left: -18px;
    width: 32px;
    height: 32px;
    border: 2px solid rgba(255, 255, 255, .7);
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .1);
    opacity: 1;
    transition: all 300ms ease;
    cursor: pointer;
    &:before {
      -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      -moz-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      -o-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      transform: translateX(-50%) translateY(-50%) rotate(-45deg);
    }
    &:after {
      -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
      -moz-transform: translateX(-50%) translateY(-50%) rotate(45deg);
      -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
      -o-transform: translateX(-50%) translateY(-50%) rotate(45deg);
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }
  }

  .view-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3001;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    visibility: hidden;
    width: calc(100% - 300px);
    background: #ebf1f4;
    /*display: none;*/
    transform: translateX(100%);
    -webkit-transition: all .22s ease-in;
    -moz-transition: all .22s ease-in;
    -ms-transition: all .22s ease-in;
    -o-transition: all .22s ease-in;
    transition: all .22s ease-in;
    &.open {
      transform: translateX(0%);
      display: flex;
      visibility: visible;
    }
    .panel-opt {
      padding: 30px;
      flex: 0;
    }
    .panel-rest{
      display: flex;
      flex: 1;
      height: 80%;
      margin: 0 30px 30px;
      flex-direction: row;
    }
    .inner-html {
      background-color: #ffffff;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      overflow: auto;
      &.loaded {
        display: block;
      }
    }
    .options{
      flex: 0 280px;
      background-color: #FFFFFF;
      margin-left: 15px;
      overflow: auto;
      .tip1{
        padding: 15px 0 17px;
        border-bottom: 1px solid #eef2f4;
        overflow: hidden;
        .title{
          font-size: 13px;
          color: #858c96;
          width: 90px;
          float: left;
          word-wrap: break-word;
        }
        .value{
          color: #000;
          margin-left: 100px;
          padding-left: 5px;
        }
      }
      .tip2{
        margin-top: 15px;
        color: #525c69;
        border-bottom: 1px solid #edeef0;
        line-height: 32px;
        &.no-border{
          border-bottom: none;
        }
        &.tip2-content{
          line-height: 1.0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// EmailView.vue?4fe12432